export interface ICommunity {
  icon: string;
  title: string;
  href: string;
  type: string;
}

export const items: ICommunity[] = [
  {
    icon: require('@/assets/icons/discord.svg'),
    title: 'Join Our Discord ',
    href: 'https://discord.gg/gogalafilm',
    type: 'discord',
  },
  {
    icon: require('@/assets/icons/iso-gala.svg'),
    title: 'Careers ',
    href: 'https://gala.com/careers',
    type: 'careers',
  },
];
